export enum EntityType {
    'HelpRequest' = 1,
    'Feedback',
    'Article',
    'Comment',
    'Report',
    'Status'
}
